import { Box, Card, CardContent, CardHeader, Grid, Link, Typography } from "@mui/material";
import careerBackground from "../assets/img/orale-taquero/career-background.webp";
import { oraleTaqueroMetalBackground } from "../config/oraleTaqueroStyles";

function PrivacyParagraph({ children }) {
    return (
        <Typography mx={{ xs: 1, sm: 4 }} my={1} align="justify" sx={{ overflowWrap: "anywhere" }}>
            {children}
        </Typography>
    );
}

export default function OraleTaqueroPrivacy() {
    return (
        <Grid
            container
            justifyContent="center"
            bgcolor="#D62812"
            lang="es"
            sx={{
                position: "relative",
                isolation: "isolate",
                clipPath: "inset(0)",
                "&::before": {
                    content: '""',
                    position: "fixed",
                    inset: "-16px",
                    zIndex: -2,
                    backgroundImage: `url(${careerBackground})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    filter: "blur(7px)",
                    pointerEvents: "none",
                },
                "&::after": {
                    content: '""',
                    position: "fixed",
                    inset: 0,
                    zIndex: -1,
                    backgroundColor: "rgba(20, 13, 9, 0.32)",
                    pointerEvents: "none",
                },
            }}
        >
            <Card
                sx={{
                    ...oraleTaqueroMetalBackground,
                    color: "#f2f4f5",
                    border: "1px solid rgba(223, 231, 237, 0.5)",
                    boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.4), inset 0 -1px 0 rgba(0, 0, 0, 0.6), 0 24px 70px rgba(0, 0, 0, 0.45)",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    marginTop: { xs: "20px", sm: "50px" },
                    marginBottom: { xs: "20px", sm: "50px" },
                    width: { xs: "95%", sm: "70%" },
                    borderRadius: "20px",
                }}
            >
                <CardHeader
                    title="POLÍTICA DE PRIVACIDAD DE ¡ÓRALE TAQUERO!"
                    subheader="Versión 1.1 · Última actualización: 18 de octubre de 2026"
                    titleTypographyProps={{ component: "h1" }}
                    align="center"
                    sx={{
                        mx: { xs: 1, sm: 4 },
                        mb: 2,
                        borderBottom: "1px solid rgba(233, 239, 244, 0.16)",
                    }}
                />
                <CardContent sx={{ "& a": { color: "#8edcff", "&:hover": { color: "#ffffff" } } }}>
                    <PrivacyParagraph>
                        <strong>Ámbito de aplicación: Internacional</strong><br /><strong>Plataformas: iOS y Android</strong>
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        1. IDENTIDAD DEL RESPONSABLE
                    </Typography>

                    <PrivacyParagraph>
                        La presente Política de Privacidad regula el tratamiento de datos personales relacionado con el videojuego <strong>¡Órale Taquero!</strong> (en adelante, la «Aplicación», el «Juego» o el «Servicio»).
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable del tratamiento de datos personales es:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Nombre:</strong> Daniel Garcia Landeros<br /><strong>Nombre comercial:</strong> KIN Solution Systems<br /><strong>Domicilio:</strong> Matteo da Montorfano No. 596, Santa María, Ocoyoacac, Estado de México, C. P. 52740, México.<br /><strong>Correo electrónico:</strong> <Link href="mailto:games@kinsolutionsystems.com">games@kinsolutionsystems.com</Link><br /><strong>País de establecimiento:</strong> México.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        KIN Solution Systems es una marca comercial registrada ante el Instituto Mexicano de la Propiedad Industrial (IMPI), bajo el número de registro 2423710. No constituye, por sí misma, una persona moral independiente.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable reconoce la importancia de la privacidad y se compromete a tratar los datos personales conforme a la legislación aplicable, mediante prácticas transparentes, legítimas y proporcionales.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Esta Política aplica a los datos tratados por el responsable en relación con el Juego, sin perjuicio de los tratamientos independientes realizados por Apple, Google, Unity y otros proveedores tecnológicos.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        2. ALCANCE DE LA POLÍTICA
                    </Typography>

                    <PrivacyParagraph>
                        Esta Política se aplica a las personas que descarguen, instalen o utilicen ¡Órale Taquero! mediante plataformas de distribución autorizadas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        También comprende los datos personales proporcionados voluntariamente en comunicaciones de soporte y aquellos tratados mediante servicios externos efectivamente integrados en el Juego.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La Aplicación está concebida para ofrecer una experiencia de entretenimiento que incluye modalidades de juego, progreso local, puntuaciones, moneda virtual, anuncios y, cuando se habiliten, compras digitales.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El tratamiento de información personal dependerá de las funcionalidades utilizadas, los permisos otorgados, las configuraciones del dispositivo y los proveedores tecnológicos activos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La mera instalación o utilización del Juego no implica una autorización general para cualquier tratamiento de datos personales. Cuando la legislación exija consentimiento específico, este se solicitará mediante el mecanismo correspondiente.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        3. INFORMACIÓN QUE PUEDE SER TRATADA
                    </Typography>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        3.1. Información técnica
                    </Typography>

                    <PrivacyParagraph>
                        Los componentes tecnológicos integrados en la Aplicación pueden tratar información técnica, como:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Modelo y características del dispositivo.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Sistema operativo y versión.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Versión de la Aplicación.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Dirección IP.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Idioma y región aproximada.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Identificadores técnicos de instalación.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Identificadores publicitarios, cuando su acceso esté permitido.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Información sobre conectividad, errores y funcionamiento.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Datos técnicos relacionados con seguridad y prevención de fraude.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        Las categorías efectivamente recopiladas dependen de la configuración y versión de los proveedores integrados.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        3.2. Información de juego
                    </Typography>

                    <PrivacyParagraph>
                        La Aplicación permite almacenar información relacionada con la experiencia del jugador, incluyendo:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Niveles completados.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Estrellas obtenidas.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Puntuaciones y récords.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Progreso del Modo Carrera.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Resultados del Modo Arcade.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Saldo de moneda virtual denominada «Taquipesos».
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Objetos cosméticos y elementos desbloqueados.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Configuraciones de audio y otras preferencias.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        Estos datos se almacenan principalmente de forma local en el dispositivo.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El almacenamiento local no significa que dicha información sea enviada automáticamente al responsable.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Si posteriormente se incorporan cuentas, almacenamiento en la nube, sincronización entre dispositivos o servicios de analítica adicionales, esta Política será actualizada para reflejar esos tratamientos.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        3.3. Información publicitaria
                    </Typography>

                    <PrivacyParagraph>
                        ¡Órale Taquero! utiliza Google AdMob / Unity LevelPlay como plataforma de mediación publicitaria.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Dicho servicio y las redes publicitarias habilitadas pueden tratar información técnica, identificadores y datos de interacción con anuncios para:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Presentar publicidad.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Controlar su frecuencia.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Medir impresiones e interacciones.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Diagnosticar problemas de entrega.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Detectar tráfico publicitario inválido.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Prevenir fraudes.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Realizar mediciones o personalización, cuando exista una base jurídica válida.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        La información concreta tratada por cada proveedor estará sujeta a sus funciones, configuraciones y políticas de privacidad.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable procurará limitar la utilización de servicios publicitarios a los tratamientos permitidos por la legislación aplicable y las preferencias del usuario.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        3.4. Compras dentro de la aplicación
                    </Typography>

                    <PrivacyParagraph>
                        Cuando se habiliten compras integradas, podrán tratarse datos necesarios para verificar, administrar y restaurar los productos adquiridos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Estos datos pueden comprender:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Identificador del producto.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Identificador de la transacción.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Estado de pago.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Información de validación proporcionada por la tienda.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Estado del derecho digital adquirido.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Información relacionada con reembolsos o revocaciones.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        Los pagos realizados mediante App Store o Google Play se procesan a través de los mecanismos de dichas plataformas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable no solicita directamente los números completos de tarjetas bancarias ni los códigos de seguridad de los medios de pago utilizados mediante esas tiendas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La información de las transacciones se utilizará únicamente para finalidades legítimas relacionadas con las compras, su seguridad, restauración y cumplimiento legal.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        3.5. Información de soporte
                    </Typography>

                    <PrivacyParagraph>
                        Si el usuario contacta voluntariamente al responsable, podrá tratarse la información necesaria para atender su solicitud.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Esto puede incluir su dirección de correo electrónico, descripción del problema, archivos adjuntos e información técnica proporcionada voluntariamente.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Se recomienda no enviar contraseñas, números completos de tarjetas, documentos oficiales ni otros datos sensibles que no sean estrictamente necesarios.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable podrá eliminar o limitar el tratamiento de información excesiva recibida de forma no solicitada.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        4. FINALIDADES DEL TRATAMIENTO
                    </Typography>

                    <PrivacyParagraph>
                        Los datos personales podrán utilizarse para las siguientes finalidades:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>A. Funcionamiento del Juego</strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Permitir la ejecución de las funcionalidades disponibles, la conservación de preferencias y el funcionamiento de los componentes técnicos necesarios.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>B. Administración de compras</strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Procesar y verificar derechos digitales, restaurar adquisiciones, gestionar incidencias y atender solicitudes relacionadas con transacciones.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>C. Publicidad</strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Presentar anuncios y administrar su funcionamiento, frecuencia y medición conforme a las bases legales y autorizaciones correspondientes.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>D. Seguridad</strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Detectar, prevenir e investigar actividades fraudulentas, accesos no autorizados y usos maliciosos de los sistemas vinculados a la Aplicación.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>E. Soporte</strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Responder comunicaciones, investigar errores y resolver incidencias.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>F. Cumplimiento legal</strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Atender obligaciones legales, solicitudes legítimas de autoridades y procedimientos administrativos o judiciales.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>G. Protección de derechos</strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Conservar y utilizar información pertinente, cuando resulte jurídicamente necesario, para establecer, ejercer o defender derechos del responsable o de terceros.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Los tratamientos opcionales que requieran consentimiento se identificarán y gestionarán separadamente.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        5. BASES LEGALES DEL TRATAMIENTO
                    </Typography>

                    <PrivacyParagraph>
                        El responsable tratará información personal cuando exista una base jurídica válida conforme a la legislación aplicable.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Estas bases pueden incluir:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Consentimiento:</strong> para tratamientos que legalmente requieran una autorización libre, específica, informada e inequívoca.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Ejecución contractual:</strong> cuando determinados datos resulten necesarios para proporcionar una funcionalidad solicitada o administrar una compra.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Cumplimiento de obligaciones legales:</strong> cuando el tratamiento sea necesario para atender requerimientos normativos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Intereses legítimos:</strong> cuando resulte apropiado para prevenir fraudes, mantener la seguridad, atender incidencias y proteger la operación del Juego, previa consideración de los derechos e intereses de las personas afectadas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable no utilizará el interés legítimo para eludir requisitos obligatorios de consentimiento.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando un tratamiento dependa del consentimiento, el usuario podrá retirarlo conforme a los mecanismos previstos en esta Política.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        6. PUBLICIDAD Y SEGUIMIENTO
                    </Typography>

                    <PrivacyParagraph>
                        El Juego puede presentar anuncios intersticiales mediante Google AdMob / Unity LevelPlay y las redes publicitarias que se encuentren activadas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Estas tecnologías pueden utilizar identificadores y otros datos técnicos para entregar anuncios, gestionar campañas, medir resultados y prevenir fraude.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando corresponda, el responsable implementará medidas para gestionar el consentimiento y las preferencias publicitarias.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        En iOS, el acceso al identificador publicitario y las actividades de seguimiento sujetas a App Tracking Transparency requerirán la autorización correspondiente.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        En Android, se respetarán los permisos, restricciones y mecanismos aplicables a los identificadores publicitarios.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando se utilicen tecnologías de publicidad personalizada, se respetarán los mecanismos de consentimiento, oposición y exclusión exigidos por las normas aplicables.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Los usuarios podrán solicitar información sobre sus opciones de privacidad mediante:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong><Link href="mailto:games@kinsolutionsystems.com">games@kinsolutionsystems.com</Link></strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        También podrán utilizar los controles disponibles en su sistema operativo o en los mecanismos de privacidad de los proveedores publicitarios.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La negativa a aceptar un tratamiento publicitario opcional no autoriza al responsable a desconocer derechos legalmente protegidos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Proveedor de mediación publicitaria:</strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Google AdMob <br /><Link href="https://policies.google.com/privacy?hl=es">https://policies.google.com/privacy?hl=es</Link>
                    </PrivacyParagraph>
                    <PrivacyParagraph>
                        Unity LevelPlay<br /><Link href="https://unity.com/legal/game-player-and-app-user-privacy-policy">https://unity.com/legal/game-player-and-app-user-privacy-policy</Link>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Las redes publicitarias adicionales que se habiliten deberán identificarse y divulgarse conforme a los requisitos legales y de las plataformas de distribución.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        7. COMPRAS DIGITALES Y PRODUCTOS PERMANENTES
                    </Typography>

                    <PrivacyParagraph>
                        La Aplicación podrá ofrecer productos digitales mediante compras integradas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Entre estos productos podrá encontrarse una compra única destinada a eliminar anuncios obligatorios.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando esta funcionalidad esté disponible, la información relacionada con la adquisición se tratará para verificar el derecho correspondiente, permitir su restauración y gestionar incidencias legítimas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La eliminación de anuncios no implica necesariamente la supresión de los registros de compra conservados legalmente por Apple, Google u otros proveedores.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable podrá conservar información mínima relacionada con una transacción cuando resulte necesaria para:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Verificar un derecho digital.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Prevenir fraudes.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Restaurar compras.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Resolver disputas legítimas.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Cumplir obligaciones fiscales o legales.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Atender requerimientos de autoridades competentes.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        Los datos se conservarán solamente durante el tiempo legalmente permitido y necesario.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Las compras podrán estar sujetas a procesos de reembolso, revocación o cancelación conforme a las reglas de la plataforma correspondiente.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        8. PREVENCIÓN DE FRAUDE Y USO ABUSIVO
                    </Typography>

                    <PrivacyParagraph>
                        El responsable podrá adoptar medidas razonables y legalmente permitidas para proteger la integridad y seguridad de ¡Órale Taquero!.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Estas medidas podrán estar destinadas a detectar o investigar situaciones como:
                    </PrivacyParagraph>

                    <Box component="ol" type="a" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Manipulación fraudulenta de comprobantes de compra.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Intentos de obtener productos digitales sin realizar válidamente el pago correspondiente.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Acceso no autorizado a sistemas o servicios.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Manipulación maliciosa de funciones de monetización.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Explotación fraudulenta de vulnerabilidades.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Interferencias deliberadas con servicios publicitarios.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Suplantación de identidad en comunicaciones o reclamaciones.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Conductas destinadas a comprometer la disponibilidad, seguridad o integridad de los servicios.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        Cuando existan indicios razonables, el responsable podrá examinar información obtenida lícitamente, realizar verificaciones proporcionadas, conservar evidencia relevante y comunicar información a terceros legitimados o autoridades competentes cuando proceda.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        También podrá adoptar restricciones técnicas proporcionadas frente a riesgos de seguridad, siempre que dichas medidas sean compatibles con la legislación aplicable.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>La conservación de evidencia no será indefinida ni autorizará la recopilación indiscriminada de información personal.</strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El ejercicio legítimo de derechos, la presentación de reclamaciones de buena fe o la negativa a aceptar seguimiento publicitario opcional no constituirán, por sí mismos, actividades fraudulentas o abusivas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable podrá ejercer las acciones legales que correspondan frente a conductas efectivamente ilícitas.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        9. COMPARTICIÓN DE INFORMACIÓN
                    </Typography>

                    <PrivacyParagraph>
                        Los datos personales podrán comunicarse a terceros cuando exista una finalidad legítima, una base jurídica adecuada y se cumplan los requisitos aplicables.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Los posibles destinatarios comprenden:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Apple y Google:</strong> para distribución, pagos, compras y servicios vinculados a sus plataformas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Unity y proveedores publicitarios:</strong> para la prestación de los servicios tecnológicos y publicitarios efectivamente habilitados.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Proveedores técnicos:</strong> cuando intervengan en la operación, mantenimiento o seguridad de servicios utilizados por la Aplicación.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Asesores profesionales:</strong> cuando resulte necesario para atender obligaciones legales o defender derechos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Autoridades competentes:</strong> cuando exista un requerimiento válido o una obligación legal.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable no divulgará información personal únicamente por recibir solicitudes informales o carentes de fundamento suficiente.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando se requiera el consentimiento para una transferencia, este deberá obtenerse mediante el mecanismo correspondiente.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El usuario podrá rechazar las transferencias que legalmente dependan de su consentimiento, sin perjuicio de aquellas permitidas por excepciones legales.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable exigirá a los encargados del tratamiento las garantías contractuales y de seguridad que correspondan.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        10. TRANSFERENCIAS INTERNACIONALES
                    </Typography>

                    <PrivacyParagraph>
                        Debido a la distribución internacional del Juego y a la utilización de proveedores tecnológicos, ciertos datos personales pueden tratarse fuera de México o del país de residencia del usuario.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Estas operaciones deberán sujetarse a los requisitos legales correspondientes.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando se requieran garantías específicas, podrán utilizarse mecanismos legalmente reconocidos, incluyendo cláusulas contractuales tipo, decisiones de adecuación u otros instrumentos válidos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La disponibilidad internacional de la Aplicación no implica que todas las funcionalidades o tratamientos estén automáticamente autorizados en todas las jurisdicciones.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable podrá restringir determinadas funciones en territorios donde no pueda satisfacer los requisitos legales correspondientes.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        11. CONSERVACIÓN Y ELIMINACIÓN DE DATOS
                    </Typography>

                    <PrivacyParagraph>
                        Los datos personales se conservarán únicamente durante el tiempo necesario para las finalidades informadas o mientras exista una obligación legal válida de conservación.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Los criterios generales serán:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Progreso local:</strong> mientras permanezca almacenado en el dispositivo o en los sistemas de respaldo correspondientes.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Datos publicitarios:</strong> conforme a las necesidades operativas y los períodos aplicables a los proveedores respectivos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Compras digitales:</strong> durante el tiempo necesario para verificar derechos, atender restauraciones, cumplir obligaciones legales y resolver controversias legítimas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Soporte:</strong> mientras resulte necesario para gestionar la solicitud y durante períodos adicionales legalmente justificados.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Incidentes de seguridad:</strong> durante el período razonablemente necesario para investigar el incidente, prevenir su repetición o defender derechos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Una vez que los datos dejen de ser necesarios, se eliminarán, anonimizarán o bloquearán conforme a la legislación aplicable.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable no conservará datos personales indefinidamente con el único argumento de que podrían resultar útiles en el futuro.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Los proveedores independientes podrán aplicar sus propios períodos de conservación.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        12. MEDIDAS DE SEGURIDAD
                    </Typography>

                    <PrivacyParagraph>
                        El responsable adoptará medidas técnicas, administrativas y organizativas proporcionadas para proteger los datos personales sometidos a su control.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Estas medidas podrán incluir:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Restricción de accesos.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Protección de credenciales y entornos administrativos.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Actualización de componentes tecnológicos.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Medidas de seguridad en las comunicaciones.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Controles destinados a prevenir accesos no autorizados.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Verificación de operaciones sensibles.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Procedimientos para gestionar incidentes.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Evaluación de riesgos y proveedores.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        Aunque ningún sistema informático puede garantizar seguridad absoluta, el responsable reconoce sus obligaciones legales de diligencia, protección y atención de incidentes.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando ocurra una vulneración de seguridad que genere obligaciones legales de notificación, se adoptarán las medidas y comunicaciones exigidas por la normativa correspondiente.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        13. DERECHOS ARCO Y SOLICITUDES DE PRIVACIDAD
                    </Typography>

                    <PrivacyParagraph>
                        Los usuarios podrán ejercer los derechos reconocidos por las leyes de protección de datos que les resulten aplicables.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        En México, estos comprenden los derechos ARCO:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Acceso:</strong> conocer qué datos personales se tratan y obtener información sobre su utilización.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Rectificación:</strong> solicitar la corrección de información inexacta o incompleta.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Cancelación:</strong> solicitar la supresión de datos cuando proceda legalmente.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Oposición:</strong> oponerse a determinados tratamientos en los supuestos establecidos por la ley.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        También podrá solicitarse la revocación del consentimiento y la limitación de determinados usos o divulgaciones.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        Procedimiento
                    </Typography>

                    <PrivacyParagraph>
                        Las solicitudes podrán enviarse a:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong><Link href="mailto:games@kinsolutionsystems.com">games@kinsolutionsystems.com</Link></strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El solicitante deberá indicar:
                    </PrivacyParagraph>

                    <Box component="ol" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Su nombre y un medio para recibir la respuesta.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            El derecho que desea ejercer.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Una descripción suficiente de los datos o tratamientos involucrados.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            La información adicional razonablemente necesaria para localizar los datos.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Los elementos indispensables para verificar su identidad o representación, cuando corresponda.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        No se solicitará documentación excesiva si existen mecanismos menos invasivos para verificar la solicitud.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Para solicitudes sujetas a la legislación mexicana, el responsable comunicará la determinación adoptada dentro de un plazo máximo de <strong>20 días</strong>, contado a partir de la recepción de la solicitud, conforme a la legislación aplicable.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Si la solicitud resulta procedente, se hará efectiva dentro de los <strong>15 días siguientes</strong> a la comunicación de la respuesta.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Los plazos podrán ampliarse en los supuestos legalmente permitidos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El ejercicio de los derechos ARCO será gratuito, sin perjuicio de los costos de reproducción o envío autorizados por la legislación.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        Solicitudes improcedentes
                    </Typography>

                    <PrivacyParagraph>
                        El responsable podrá rechazar total o parcialmente una solicitud únicamente cuando exista una causa legal válida.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Entre otros supuestos, esto podrá ocurrir cuando:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            No se acredite razonablemente la identidad o representación.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Los datos no estén bajo el control del responsable.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Su cumplimiento afecte derechos de terceros.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Exista un impedimento legal.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Una autoridad competente haya ordenado conservar determinada información.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            La solicitud ya haya sido satisfecha en los términos previstos por la legislación.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        Cuando se deniegue una solicitud, se comunicarán las razones legalmente procedentes.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        14. DERECHOS DE USUARIOS INTERNACIONALES
                    </Typography>

                    <PrivacyParagraph>
                        Dependiendo del país de residencia y del ámbito de aplicación de las leyes correspondientes, los usuarios podrán tener derechos adicionales.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        Unión Europea y Reino Unido
                    </Typography>

                    <PrivacyParagraph>
                        Cuando resulte aplicable el Reglamento General de Protección de Datos o la legislación equivalente del Reino Unido, podrán ejercerse derechos de acceso, rectificación, supresión, portabilidad, limitación, oposición y retirada del consentimiento.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        También podrá presentarse una reclamación ante la autoridad de control competente.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando resulte legalmente exigible, el responsable designará los representantes correspondientes y pondrá sus datos de contacto a disposición de los interesados.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        Estados Unidos
                    </Typography>

                    <PrivacyParagraph>
                        Los usuarios residentes en determinados estados podrán contar con derechos de acceso, eliminación, corrección y exclusión de determinados tratamientos de publicidad dirigida o comunicaciones de datos.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Estos derechos se atenderán conforme a las leyes estatales aplicables al responsable y a las actividades de tratamiento.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando exista una obligación de reconocer señales de exclusión o mecanismos específicos de privacidad, se implementarán los controles correspondientes.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        Brasil
                    </Typography>

                    <PrivacyParagraph>
                        Cuando resulte aplicable la Lei Geral de Proteção de Dados Pessoais (LGPD), se reconocerán los derechos previstos por dicha legislación.
                    </PrivacyParagraph>

                    <Typography component="h3" variant="subtitle1" fontWeight="bold" mx={{ xs: 1, sm: 4 }} mt={2} mb={1}>
                        Otras jurisdicciones
                    </Typography>

                    <PrivacyParagraph>
                        Los usuarios de otras regiones podrán ejercer los derechos de protección de datos reconocidos por la legislación aplicable.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Esta Política no pretende limitar derechos irrenunciables ni restringir la competencia de las autoridades que correspondan.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        15. PRIVACIDAD DE MENORES
                    </Typography>

                    <PrivacyParagraph>
                        ¡Órale Taquero! deberá cumplir los requisitos de privacidad y protección de menores correspondientes a su clasificación por edades, audiencia objetivo y territorios de distribución.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando las leyes o las políticas de las tiendas exijan protecciones específicas, el responsable adoptará las medidas correspondientes.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Estas podrán incluir:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Restricciones al uso de identificadores.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Limitaciones de publicidad personalizada.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Configuraciones de tratamiento infantil.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Uso de proveedores publicitarios permitidos.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Consentimiento parental cuando corresponda.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Restricciones al tratamiento de información de menores.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        No se utilizarán datos personales de menores para finalidades publicitarias prohibidas por la legislación aplicable.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Los padres, madres o representantes legales podrán presentar solicitudes relacionadas con datos personales de menores mediante:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong><Link href="mailto:games@kinsolutionsystems.com">games@kinsolutionsystems.com</Link></strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable podrá requerir una acreditación proporcionada de la representación cuando sea necesaria.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La clasificación por edades y las medidas de protección deberán coincidir con la audiencia real del Juego y las configuraciones de App Store, Google Play y las redes publicitarias.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        16. CONTROLES DE PRIVACIDAD
                    </Typography>

                    <PrivacyParagraph>
                        Los usuarios podrán utilizar los mecanismos de privacidad ofrecidos por el sistema operativo, los proveedores externos y la Aplicación cuando estén disponibles.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Estos mecanismos pueden incluir:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Ajustes relativos al seguimiento publicitario.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Restricciones al uso de identificadores.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Revocación del consentimiento.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Oposición a tratamientos de publicidad dirigida.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Solicitudes de eliminación.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Consultas sobre las prácticas de los proveedores.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        Las solicitudes podrán enviarse a:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong><Link href="mailto:games@kinsolutionsystems.com">games@kinsolutionsystems.com</Link></strong>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando el tratamiento corresponda a un responsable independiente, también podrá resultar necesario ejercer los derechos directamente ante dicho proveedor.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable facilitará la información razonablemente necesaria para identificar el canal correspondiente.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        17. DESINSTALACIÓN Y ELIMINACIÓN DE INFORMACIÓN
                    </Typography>

                    <PrivacyParagraph>
                        El usuario podrá desinstalar ¡Órale Taquero! mediante los mecanismos de su dispositivo.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La eliminación de la Aplicación puede provocar la eliminación de determinados datos locales.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Sin embargo, algunos datos podrían mantenerse en respaldos del dispositivo, registros de las tiendas o sistemas de proveedores independientes.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La desinstalación no constituye necesariamente una solicitud de supresión de los datos sometidos al control del responsable.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Para solicitar dicha supresión, el usuario podrá comunicarse mediante el canal de privacidad indicado.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando existan motivos legales para conservar determinada información, el responsable podrá limitar la supresión a los datos respecto de los cuales no exista una obligación válida de conservación.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        18. PROTECCIÓN DE LOS DERECHOS DEL RESPONSABLE
                    </Typography>

                    <PrivacyParagraph>
                        El responsable podrá ejercer los derechos que le correspondan conforme a la legislación aplicable para proteger sus sistemas, activos digitales, información y operaciones legítimas.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Esto incluye la posibilidad de conservar evidencia pertinente y promover acciones legales frente a conductas fraudulentas, accesos ilícitos, falsificación de transacciones u otros actos que generen responsabilidades legales.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La información utilizada para estas finalidades deberá haber sido obtenida legítimamente y tratarse conforme a los principios de necesidad, proporcionalidad, seguridad y limitación temporal.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Ninguna disposición de esta Política autoriza la recopilación indiscriminada de datos, el acceso ilegítimo a dispositivos, la vigilancia injustificada o la divulgación arbitraria de información personal.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable podrá defenderse frente a reclamaciones improcedentes mediante los procedimientos legales correspondientes, sin afectar el derecho de los usuarios a ejercer acciones legítimas o acudir ante las autoridades competentes.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        19. LIMITACIONES Y RESPONSABILIDADES
                    </Typography>

                    <PrivacyParagraph>
                        La Aplicación utiliza tecnologías, sistemas operativos y servicios externos cuyo funcionamiento puede depender de proveedores independientes.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        El responsable no controla necesariamente todas las operaciones técnicas, configuraciones o decisiones de tratamiento realizadas por dichos proveedores.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        No obstante, reconoce que puede tener obligaciones respecto de la selección de proveedores, la transparencia, las medidas de seguridad y los tratamientos efectuados por su cuenta.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La existencia de servicios externos no constituye una exención general de responsabilidad.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        La disponibilidad de funcionalidades podrá modificarse cuando resulte necesario para cumplir requisitos técnicos, legales o de seguridad, sin perjuicio de los derechos de los consumidores y titulares de datos personales.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        20. MODIFICACIONES DE LA POLÍTICA
                    </Typography>

                    <PrivacyParagraph>
                        El responsable podrá actualizar esta Política cuando existan cambios en:
                    </PrivacyParagraph>

                    <Box component="ul" sx={{ mx: { xs: 1, sm: 4 }, my: 2, pl: 3 }}>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            La legislación aplicable.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Los servicios tecnológicos utilizados.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Las redes publicitarias.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Las funcionalidades del Juego.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Los mecanismos de compras.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Las prácticas de tratamiento de datos.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Los procedimientos de seguridad.
                        </Typography>
                        <Typography component="li" my={1} sx={{ overflowWrap: "anywhere" }}>
                            Los mecanismos de ejercicio de derechos.
                        </Typography>
                    </Box>

                    <PrivacyParagraph>
                        La versión actualizada indicará su fecha de modificación.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Cuando los cambios sean sustanciales, se informará mediante medios apropiados y se solicitará un nuevo consentimiento cuando sea legalmente necesario.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Las modificaciones no podrán utilizarse para eliminar retroactivamente derechos irrenunciables ni legitimar automáticamente tratamientos que requieran una autorización adicional.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        21. LEGISLACIÓN APLICABLE
                    </Typography>

                    <PrivacyParagraph>
                        Esta Política toma como referencia la legislación mexicana de protección de datos personales, considerando que el responsable se encuentra establecido en México.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Sin perjuicio de lo anterior, podrán resultar aplicables normas de otras jurisdicciones atendiendo a la ubicación de los usuarios, las actividades del responsable y los criterios territoriales de cada legislación.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Las normas imperativas de protección de datos prevalecerán sobre cualquier disposición incompatible de esta Política.
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Ninguna cláusula pretende impedir el ejercicio de derechos, limitar facultades de autoridades competentes ni excluir responsabilidades que legalmente no puedan limitarse.
                    </PrivacyParagraph>

                    <Typography component="h2" variant="h6" mx={{ xs: 1, sm: 4 }} mt={3} mb={1}>
                        22. CONTACTO
                    </Typography>

                    <PrivacyParagraph>
                        Para consultas, reclamaciones, solicitudes de acceso, rectificación, cancelación, oposición, revocación de consentimiento o cualquier cuestión relacionada con la privacidad:
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Responsable:</strong> Daniel Garcia Landeros<br /><strong>Nombre comercial:</strong> KIN Solution Systems<br /><strong>Aplicación:</strong> ¡Órale Taquero!
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Domicilio:</strong><br />Matteo da Montorfano No. 596<br />Santa María<br />Ocoyoacac, Estado de México<br />C. P. 52740<br />México
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        <strong>Correo electrónico:</strong><br /><Link href="mailto:games@kinsolutionsystems.com">games@kinsolutionsystems.com</Link>
                    </PrivacyParagraph>

                    <PrivacyParagraph>
                        Las solicitudes serán atendidas conforme a los procedimientos y plazos establecidos por la legislación aplicable.
                    </PrivacyParagraph>
                </CardContent>
            </Card>
        </Grid>
    );
}
